import * as React from 'react';

interface Props {
  currentMail: boolean;
}

const CommunicationHead = ({ currentMail }: Props) => {
  if (currentMail) {
    return(
      <div className='d-flex' >
        <div className='communication-head second-communication'>
          {'Email'}
        </div>
        <div className='communication-head third-communication'>
          {'Subject'}
        </div>
        <div className='communication-head fourth-communication'>
          {'Status'}
        </div>
        <div className='communication-head first-communication'>
          {'Date'}
        </div>
      </div>
    );
  } else {
    return(
      <div className='d-flex' >
        <div className='communication-head second-communication history-mail'>
          {'Email'}
        </div>
        <div className='communication-head third-communication history-mail'>
          {'Subject'}
        </div>
        <div className='communication-head first-communication history-mail'>
          {'Date'}
        </div>
      </div>
    );
  }
};

export default React.memo(CommunicationHead);
